import Arthur from "../images/Arthur.png"
import Joan from "../images/Joan.png"
import Jack from "../images/Jack.png"
import Aurelius from "../images/Aurelius.png"
import Francois from "../images/Francois.png"
import Magnus from "../images/Magnus.png"
import Archie from "../images/Archie.png"
import Matilda from "../images/Matilda.png"
import Billie from "../images/Billie.png"

export const troops = {
    1: ["Stone", "Farm", "Spartan", "Renaissance", "Modern", "Space"],
    2: ["Neolithic", "Bronze", "Samurai", "British Empire", "World Wars", "Robot"],
    3: ["Jungle", "Egyptian", "Roman", "Dynasty", "Cold War", "Alien"],
    4: ["Ice", "Mayan", "Viking", "Native American", "Post Apocalypse", "Cyborg"],
    5: ["Swamp", "Mauryan", "Fantasy", "Cowboy", "Police", "Virtual"],
    6: ["Mountain", "Celtic", "Middle Ages", "Pirate", "Gangster", "Quantum"],
    7: ["Shore", "Barbarian", "Huns", "Slavic", "Mafia", "Mutant"],
    8: ["Stone", "Egyptian", "Viking", "Cowboy", "Gangster", "Space"],
    9: ["Neolithic", "Mayan", "Fantasy", "Pirate", "Mafia", "Robot"],
    10: ["Jungle", "Mauryan", "Middle Ages", "Slavic", "Modern", "Alien"],
    11: ["Ice", "Celtic", "Huns", "Renaissance", "World Wars", "Cyborg"],
    12: ["Swamp", "Barbarian", "Spartan", "British Empire", "Cold War", "Virtual"],
    13: ["Mountain", "Farm", "Samurai", "Dynasty", "Post Apocalypse", "Quantum"],
    14: ["Shore", "Bronze", "Roman", "Native American", "Police", "Mutant"],
    15: ["Stone", "Mauryan", "Spartan", "Pirate", "Modern", "Cyborg"],
    16: ["Neolithic", "Celtic", "Samurai", "Slavic", "World Wars", "Virtual"],
    17: ["Jungle", "Barbarian", "Roman", "Renaissance", "Cold War", "Quantum"],
    18: ["Ice", "Farm", "Viking", "British Empire", "Post Apocalypse", "Mutant"],
    19: ["Swamp", "Bronze", "Fantasy", "Dynasty", "Police", "Space"],
    20: ["Mountain", "Egyptian", "Middle Ages", "Native American", "Gangster", "Robot"],
    21: ["Shore", "Mayan", "Huns", "Cowboy", "Mafia", "Alien"]
}
export const foods = {
    1: [0.0899033, 2.904],
    2: [0.149916, 4.80387],
    3: [0.209544,6.81326],
    4: [0.149916, 4.85287],
    5: [], //not calculated yet...
    6: [],
    7: [],
    8: [],
    9: []
}
export const statCaps = {
    "Range": 1,
    "AttackSpeed": 1,
    "CritChance": 0.125,
    "CritAttack": 6.27,
    "BlockChance": 0.125,
    "MoveSpeed": 1,
    "LifeSteal": 0
};
export const heroCard = [
    { 
        "name": "Arthur",
        "image": Arthur,
        "stats": {
            "Attack": 1.30,
            "Health": 1.30,
            "Range": 1,
            "AttackSpeed": 0.4432,
            "CritChance": 0,
            "CritAttack": 1.20,
            "BlockChance": 0,
            "MoveSpeed": 1,
            "LifeSteal": 0
        },
        "hits": 0.5
}, 
{ 
        "name": "Joan",
        "image": Joan,
        "stats": {
            "Attack": 1.30,
            "Health": 1.60,
            "Range": 1.10,
            "AttackSpeed": 0.3478,
            "CritChance": 0,
            "CritAttack": 1.20,
            "BlockChance": 0,
            "MoveSpeed": 1,
            "LifeSteal": 0
        },
        "hits": 0.5
},
{ 
        "name": "Jack",
        "image": Jack,
        "stats": {
            "Attack": 1.20,
            "Health": 1.0,
            "Range": 1,
            "AttackSpeed": 0.5115,
            "CritChance": 0,
            "CritAttack": 1.20,
            "BlockChance": 0,
            "MoveSpeed": 1,
            "LifeSteal": 0
        },
        "hits": 0.5
},
{ 
        "name": "Aurelius",
        "image": Aurelius,
        "stats": {
            "Attack": 1.50,
            "Health": 0.70,
            "Range": 2,
            "AttackSpeed": 0.4222,
            "CritChance": 0,
            "CritAttack": 1.20,
            "BlockChance": 0,
            "MoveSpeed": 1,
            "LifeSteal": 0
        },
        "hits": 0.55
},
{ 
        "name": "Francois",
        "image": Francois,
        "stats": {
            "Attack": 1.00,
            "Health": 1.00,
            "Range": 1,
            "AttackSpeed": 0.65,
            "CritChance": 0,
            "CritAttack": 1.20,
            "BlockChance": 0,
            "MoveSpeed": 1,
            "LifeSteal": 0
        },
        "hits": 0.5
},
{ 
        "name": "Magnus",
        "image": Magnus,
        "stats": {
            "Attack": 1.00,
            "Health": 0.50,
            "Range": 10,
            "AttackSpeed": 0.3489,
            "CritChance": 0,
            "CritAttack": 1.20,
            "BlockChance": 0,
            "MoveSpeed": 1,
            "LifeSteal": 0
        },
        "hits": 2.54777
},
{ 
        "name": "Archie",
        "image": Archie,
        "stats": {
            "Attack": 1.00,
            "Health": 0.80,
            "Range": 7.10,
            "AttackSpeed": 0.4418,
            "CritChance": 0,
            "CritAttack": 1.20,
            "BlockChance": 0,
            "MoveSpeed": 1,
            "LifeSteal": 0
        },
        "hits": 2.1739
},
{ 
        "name": "Matilda",
        "image": Matilda,
        "stats": {
            "Attack": 1.00,
            "Health": 0.80,
            "Range": 7.10,
            "AttackSpeed": 0.3467,
            "CritChance": 0,
            "CritAttack": 1.20,
            "BlockChance": 0,
            "MoveSpeed": 1,
            "LifeSteal": 0
        },
        "hits": 2.0548
},
{ 
        "name": "Billie",
        "image": Billie,
        "stats": {
            "Attack": 0.40,
            "Health": 0.50,
            "Range": 10,
            "AttackSpeed": 0.6979,
            "CritChance": 0,
            "CritAttack": 1.20,
            "BlockChance": 0,
            "MoveSpeed": 1,
            "LifeSteal": 0
        },
        "hits": 5
},
]

export const BiSGear = 
    {"Weapon1": "Ruby Sword",
     "Weapon2": "Siren",
     "Ring": "Cobalt",
     "Necklace": "Mountain Blood",
     "Armor": "S.C.A-02",
     "Helmet": "Crown"   
    }

export const Helmets = [
    {
        "name": "Crown",
        "rarity": "Legendary",
        "stats": {
            "CritChance": 0.08,
            "CritAttack": 2.0
        }
    },
    {
        "name": "Magnetor",
        "rarity": "Legendary",
        "stats": {
            "CritChance": 0.08,
            "BlockChance": 0.05
        }
    },
    {
        "name": "Third-Eye",
        "rarity": "Legendary",
        "stats": {
            "Health": 0.82,
            "BlockChance": 0.04
        }
    },
    {
        "name": "Titan",
        "rarity": "Legendary",
        "stats": {
            "Health": 0.58,
            "CritAttack": 2.50
        }
    },
    {
        "name": "Sabotron",
        "rarity": "Legendary",
        "stats": {
            "Health": 0.70,
            "MoveSpeed": 0.80
        }
    },
    {
        "name": "Stalker",
        "rarity": "Epic",
        "stats": {
            "Health": 0.28,
            "CritAttack": 0.8
        }
    },
     {
        "name": "Pilot",
        "rarity": "Epic",
        "stats": {
            "Health": 0.33,
            "BlockChance": 0.02
        }
    },
     {
        "name": "Herzog",
        "rarity": "Epic",
        "stats": {
            "Health": 0.28,
            "AttackSpeed": 0.23
        }
    },
     {
        "name": "Mercury",
        "rarity": "Epic",
        "stats": {
            "CritChance": 0.04,
            "CritAttack": 0.8
        }
    },
     {
        "name": "Necromancer",
        "rarity": "Epic",
        "stats": {
            "CritChance": 0.04,
            "MoveSpeed": 0.4
        }
    },
     {
        "name": "Barbarian",
        "rarity": "Rare",
        "stats": {
            "Health": 0.23,
        }
    },
     {
        "name": "Sorcerer",
        "rarity": "Rare",
        "stats": {
            "Health": 0.23,
        }
    },
    {
        "name": "Leonidas",
        "rarity": "Rare",
        "stats": {
            "Health": 0.23,
        }
    },
    {
        "name": "A.C.H",
        "rarity": "Rare",
        "stats": {
            "CritChance": 0.03,
        }
    },
    {
        "name": "Hachiman",
        "rarity": "Rare",
        "stats": {
            "AttackSpeed": 0.23,
        }
    },
    {
        "name": "Thor's Cap",
        "rarity": "Common",
        "stats": {
            "Health": 0.12,
        }
    },
     {
        "name": "Saber Tooth",
        "rarity": "Common",
        "stats": {
            "CritChance": 0.01,
        }
    },
    {
        "name": "Mask",
        "rarity": "Common",
        "stats": {
            "Health": 0.12,
        }
    },
    {
        "name": "Special Ops",
        "rarity": "Common",
        "stats": {
            "MoveSpeed": 0.10,
        }
    },
    {
        "name": "Better Batter",
        "rarity": "Common",
        "stats": {
            "Health": 0.12,
        }
    }

]

export const Weapons = [
    {
        "name": "Ruby Sword",
        "rarity": "Legendary",
        "stats": {
            "CritChance": 0.08,
            "AttackSpeed": 0.46
        }
    },
    {
        "name": "Quantum",
        "rarity": "Legendary",
        "stats": {
            "Attack": 0.58,
            "LifeSteal": 0.08
        }
    },
    {
        "name": "NH-2D",
        "rarity": "Legendary",
        "stats": {
            "Attack": 0.7,
            "CritAttack": 2
        }
    },
    {
        "name": "Siren",
        "rarity": "Legendary",
        "stats": {
            "CritChance": 0.08,
            "CritAttack": 2
        }
    },
    {
        "name": "Diamond Shard",
        "rarity": "Legendary",
        "stats": {
            "Attack": 0.82,
            "CritChance": 0.04
        }
    },
    {
        "name": "Ronin",
        "rarity": "Epic",
        "stats": {
            "Attack": 0.33,
            "CritChance": 0.02
        }
    },
     {
        "name": "Dragon Tooth",
        "rarity": "Epic",
        "stats": {
            "CritChance": 0.04,
            "AttackSpeed": 0.19
        }
    },
     {
        "name": "Cutlass",
        "rarity": "Epic",
        "stats": {
            "CritChance": 0.04,
            "CritAttack": 0.8
        }
    },
     {
        "name": "Holographer",
        "rarity": "Epic",
        "stats": {
            "Attack": 0.28,
            "CritAttack": 0.8
        }
    },
     {
        "name": "Bronze Fang",
        "rarity": "Epic",
        "stats": {
            "Attack": 0.23,
            "CritChance": 0.03
        }
    },
     {
        "name": "Macuahuitl",
        "rarity": "Rare",
        "stats": {
            "Attack": 0.23,
        }
    },
     {
        "name": "Scythe",
        "rarity": "Rare",
        "stats": {
            "Attack": 0.23,
        }
    },
    {
        "name": "Serpent",
        "rarity": "Rare",
        "stats": {
            "MoveSpeed": 0.20,
        }
    },
    {
        "name": "Justice",
        "rarity": "Rare",
        "stats": {
            "CritChance": 0.03,
        }
    },
    {
        "name": "Rapier",
        "rarity": "Rare",
        "stats": {
            "Attack": 0.23,
        }
    },
    {
        "name": "Heirloom",
        "rarity": "Common",
        "stats": {
            "Attack": 0.12,
        }
    },
     {
        "name": "Club",
        "rarity": "Common",
        "stats": {
            "Attack": 0.12,
        }
    },
    {
        "name": "K-74",
        "rarity": "Common",
        "stats": {
            "CritChance": 0.01,
        }
    },
    {
        "name": "Baton",
        "rarity": "Common",
        "stats": {
            "MoveSpeed": 0.10,
        }
    },
    {
        "name": "Ice Shard",
        "rarity": "Common",
        "stats": {
            "Attack": 0.12,
        }
    }
]

export const Armor = [
    {
        "name": "Dragon Plates",
        "rarity": "Legendary",
        "stats": {
            "Health": 0.7,
            "AttackSpeed": 0.47
        }
    },
    {
        "name": "White Knight",
        "rarity": "Legendary",
        "stats": {
            "Health": 0.82,
            "BlockChance": 0.04
        }
    },
    {
        "name": "S.C.A.-02",
        "rarity": "Legendary",
        "stats": {
            "CritChance": 0.08,
            "CritAttack": 2
        }
    },
    {
        "name": "Basilisk Scales",
        "rarity": "Legendary",
        "stats": {
            "CritChance": 0.08,
            "BlockChance": 0.05
        }
    },
    {
        "name": "SWAT",
        "rarity": "Legendary",
        "stats": {
            "Health": 0.58,
            "CritAttack": 2.5
        }
    },
    {
        "name": "Nightingale",
        "rarity": "Epic",
        "stats": {
            "Health": 0.23,
            "MoveSpeed": 0.4
        }
    },
     {
        "name": "Panzer",
        "rarity": "Epic",
        "stats": {
            "CritChance": 0.03,
            "CritAttack": 0.8
        }
    },
     {
        "name": "Chromium",
        "rarity": "Epic",
        "stats": {
            "Health": 0.28,
            "CritAttack": 0.80
        }
    },
     {
        "name": "Cuirass",
        "rarity": "Epic",
        "stats": {
            "BlockChance": 0.02,
            "Health": 0.33
        }
    },
     {
        "name": "Anubis Tunic",
        "rarity": "Epic",
        "stats": {
            "CritChance": 0.03,
            "AttackSpeed": 0.19
        }
    },
     {
        "name": "Sakura",
        "rarity": "Rare",
        "stats": {
            "CritChance": 0.03,
        }
    },
     {
        "name": "Oakskin",
        "rarity": "Rare",
        "stats": {
            "Health": 0.23,
        }
    },
    {
        "name": "Primal",
        "rarity": "Rare",
        "stats": {
            "MoveSpeed": 0.20,
        }
    },
    {
        "name": "Spartacus",
        "rarity": "Rare",
        "stats": {
            "Health": 0.23,
        }
    },
    {
        "name": "Palladin",
        "rarity": "Rare",
        "stats": {
            "Health": 0.23,
        }
    },
    {
        "name": "Super Bowl",
        "rarity": "Common",
        "stats": {
            "AttackSpeed": 0.11,
        }
    },
     {
        "name": "Captain",
        "rarity": "Common",
        "stats": {
            "Health": 0.12,
        }
    },
    {
        "name": "Robin",
        "rarity": "Common",
        "stats": {
            "Health": 0.12,
        }
    },
    {
        "name": "Scrap Yard",
        "rarity": "Common",
        "stats": {
            "Health": 0.12,
        }
    },
    {
        "name": "Skeleton",
        "rarity": "Common",
        "stats": {
            "CritChance": 0.01,
        }
    }
]
export const Ring = [
    {
        "name": "Seraph",
        "rarity": "Legendary",
        "stats": {
            "Health": 0.82,
            "Attack": 0.35
        }
    },
    {
        "name": "Elemental",
        "rarity": "Legendary",
        "stats": {
            "Health": 0.70,
            "LifeSteal": 0.07
        }
    },
    {
        "name": "Cobalt",
        "rarity": "Legendary",
        "stats": {
            "Attack": 0.58,
            "CritChance": 0.07
        }
    },
    {
        "name": "Chroma ring",
        "rarity": "Legendary",
        "stats": {
            "Health": 0.70,
            "BlockChance": 0.05
        }
    },
    {
        "name": "Q-Aura",
        "rarity": "Legendary",
        "stats": {
            "LifeSteal": 0.10,
            "MoveSpeed": 0.8
        }
    },
    {
        "name": "Talons",
        "rarity": "Epic",
        "stats": {
            "LifeSteal": 0.04,
            "AttackSpeed": 0.19
        }
    },
     {
        "name": "Wisdom",
        "rarity": "Epic",
        "stats": {
            "Health": 0.28,
            "MoveSpeed": 0.4
        }
    },
     {
        "name": "Gold Ring",
        "rarity": "Epic",
        "stats": {
            "Health": 0.28,
            "BlockChance": 0.02
        }
    },
     {
        "name": "Twins",
        "rarity": "Epic",
        "stats": {
            "Attack": 0.23,
            "Health": 0.14
        }
    },
     {
        "name": "Skeleton",
        "rarity": "Epic",
        "stats": {
            "Attack": 0.23,
            "CritAttack": 1
        }
    },
     {
        "name": "Oath Band",
        "rarity": "Rare",
        "stats": {
            "Attack": 0.23,
        }
    },
     {
        "name": "Unbroken Bond",
        "rarity": "Rare",
        "stats": {
            "AttackSpeed": 0.23,
        }
    },
    {
        "name": "Hexa",
        "rarity": "Rare",
        "stats": {
            "Health": 0.23,
        }
    },
    {
        "name": "Tusk",
        "rarity": "Rare",
        "stats": {
            "Health": 0.23,
        }
    },
    {
        "name": "Star Seal",
        "rarity": "Rare",
        "stats": {
            "Attack": 0.23,
        }
    },
    {
        "name": "Copper",
        "rarity": "Common",
        "stats": {
            "Health": 0.12,
        }
    },
     {
        "name": "Frat Ring",
        "rarity": "Common",
        "stats": {
            "Health": 0.12,
        }
    },
    {
        "name": "Meteorite",
        "rarity": "Common",
        "stats": {
            "Attack": 0.12,
        }
    },
    {
        "name": "Jungle Eye",
        "rarity": "Common",
        "stats": {
            "Health": 0.12,
        }
    },
    {
        "name": "Primal",
        "rarity": "Common",
        "stats": {
            "Attack": 0.12,
        }
    }
]

export const Necklace = [
    {
        "name": "Crystal",
        "rarity": "Legendary",
        "stats": {
            "Attack": 0.82,
            "Health": 0.35
        }
    },
    {
        "name": "Mountain Blood",
        "rarity": "Legendary",
        "stats": {
            "Attack": 0.58,
            "CritAttack": 2.5
        }
    },
    {
        "name": "Gravity Bend",
        "rarity": "Legendary",
        "stats": {
            "Health": 0.7,
            "LifeSteal": 0.07
        }
    },
    {
        "name": "Venom",
        "rarity": "Legendary",
        "stats": {
            "Health": 0.7,
            "BlockChance": 0.05
        }
    },
    {
        "name": "Void",
        "rarity": "Legendary",
        "stats": {
            "LifeSteal": 0.1,
            "MoveSpeed": 0.8
        }
    },
     {
        "name": "Chrono Shatter",
        "rarity": "Epic",
        "stats": {
            "Health": 0.28,
            "BlockChance": 0.02
        }
    },
     {
        "name": "Duke",
        "rarity": "Epic",
        "stats": {
            "LifeSteal": 0.04,
            "BlockChance": 0.02
        }
    },
     {
        "name": "Inherited Power",
        "rarity": "Epic",
        "stats": {
            "Health": 0.28,
            "AttackSpeed": 0.19
        }
    },
     {
        "name": "Roi",
        "rarity": "Epic",
        "stats": {
            "Attack": 0.23,
            "CritAttack": 1
        }
    },
     {
        "name": "Key Secret",
        "rarity": "Epic",
        "stats": {
            "Attack": 0.33,
            "Health": 0.14
        }
    },
     {
        "name": "Moon Pearls",
        "rarity": "Rare",
        "stats": {
            "Health": 0.23,
        }
    },
     {
        "name": "Snow Wolf",
        "rarity": "Rare",
        "stats": {
            "Attack": 0.23,
        }
    },
    {
        "name": "Mjolnir",
        "rarity": "Rare",
        "stats": {
            "Attack": 0.23,
        }
    },
    {
        "name": "Doom Chain",
        "rarity": "Rare",
        "stats": {
            "CritChance": 0.03,
        }
    },
    {
        "name": "Gambler",
        "rarity": "Rare",
        "stats": {
            "Health": 0.23,
        }
    },
    {
        "name": "Lady Luck",
        "rarity": "Common",
        "stats": {
            "MoveSpeed": 0.1,
        }
    },
     {
        "name": "Precious",
        "rarity": "Common",
        "stats": {
            "Health": 0.12,
        }
    },
    {
        "name": "Dog Tags",
        "rarity": "Common",
        "stats": {
            "Attack": 0.12,
        }
    },
    {
        "name": "Biter",
        "rarity": "Common",
        "stats": {
            "Health": 0.12,
        }
    },
    {
        "name": "Shaman",
        "rarity": "Common",
        "stats": {
            "Attack": 0.12,
        }
    }
]
export const multiplier = {
    'k': 1,
    'm': 2,
    'b': 3,
    't': 4,
  };
export const suffixes = [
      "", "k", "m", "b", "t", "A", "B", "C", "D", "E", "F", "G",
      "H", "I", "J", "K", "L", "M", "N", "O", "P", "Q", "R", "S",
      "T", "U", "V", "W", "X", "Y", "Z", "AA", "AB", "AC", "AD", "AE",
      "AF", "AG", "AH", "AI", "AJ", "AK", "AL", "AM", "AN", "AO", "AP", "AQ", 
      "AR", "AS", "AT", "AU", "AV", "AW", "AX", "AY", "AZ", "BA", "BB", "BC", 
      "BD", "BE", "BF", "BG", "BH", "BI", "BJ", "BK", "BL", "BM", "BN", "BO", 
      "BP", "BQ", "BR", "BS", "BT", "BU", "BV", "BW", "BX", "BY", "BZ", "CA",
      "CB", "CC", "CD", "CE", "CF", "CG", "CH", "CI", "CJ", "CK", "CL", "CM", 
      "CN", "CO", "CP", "CQ", "CR", "CS", "CT", "CU", "CV", "CW", "CX", "CY", 
      "CZ", "DA", "DB", "DC", "DD", "DE", "DF", "DG", "DH", "DI", "DJ", "DK", 
      "DL", "DM", "DN", "DO", "DP", "DQ", "DR", "DS", "DT", "DU", "DV", "DW", 
      "DX", "DY", "DZ", "EA", "EB", "EC", "ED", "EE", "EF", "EG", "EH", "EI", 
      "EJ", "EK", "EL", "EM", "EN", "EO", "EP", "EQ", "ER", "ES", "ET", "EU", 
      "EV", "EW", "EX", "EY", "EZ"
    ];
    export const cards = {
    'Legendary': [
      {
      'name':'T-Rex',
      'stat': 'Attack'},
      {
      'name':'Robot-Head',
      'stat': 'Health'
      }],
    'Epic': 
    [
      {
      'name':'Cave Painting',
      'stat': 'Attack'},
      {
      'name':'UAV',
      'stat': 'Attack'
      },
      {
      'name':'Obelisk',
      'stat': 'Health'},
      {
      'name':'Military Radio',
      'stat': 'Health'
      }],
    'Rare': 
    [
      {
      'name':'Trojan Horse',
      'stat': 'Attack'},
      {
      'name':'Red Rose',
      'stat': 'Attack'
      },
      {
      'name':'Sabre Cat Skull',
      'stat': 'Attack'},
      {
      'name':'Gun Powder',
      'stat': 'Attack'
      },
      {
      'name':'Kevlar Thread',
      'stat': 'Health'},
      {
      'name':'Fountain of Life',
      'stat': 'Health'
      },
      {
      'name':'Stem C5',
      'stat': 'Health'
      },
      {
      'name':'Pestle and Mortar',
      'stat': 'Health'
      }
      ],
    'Common': 
    [
      {
      'name':'Combat Dummy',
      'stat': 'Attack'},
      {
      'name':'Vial of Poison',
      'stat': 'Attack'
      },
      {
      'name':'Weights',
      'stat': 'Attack'},
      {
      'name':'Anvil',
      'stat': 'Attack'
      },
      {
      'name':'Target',
      'stat': 'Attack'},
      {
      'name':'Grind Stone',
      'stat': 'Attack'
      },
      {
      'name':'Battle Horn',
      'stat': 'Attack'},
      {
      'name':'War Banner',
      'stat': 'Attack'
      },
      {
      'name':'Ancient Emblem',
      'stat': 'Health'},
      {
      'name':'Furnace',
      'stat': 'Health'
      },
      {
      'name':'Canned Food',
      'stat': 'Health'},
      {
      'name':'Crop Seeds',
      'stat': 'Health'
      },
      {
      'name':'Bandages',
      'stat': 'Health'},
      {
      'name':'Turtle Shell',
      'stat': 'Health'
      },
      {
      'name':'Dino Ribs',
      'stat': 'Health'},
      {
      'name':'Camp Fire',
      'stat': 'Health'
      }
      ]
  }

  export const cardVals = {
    'Ultimate':
    [
        {
            'Attack': [
                {
                    'base': 2.5
                },
                {
                    'multi': 1.25
                },
            ]  
        },
        {
            'Health': [
                {
                    'base': 2.5
                },
                {
                    'multi': 1.25
                },
            ]  
        },
        {
            'Base': [
                {
                    'base': 2.5
                },
                {
                    'multi': 1.25
                },
            ]  
        }
    ],
    'Legendary':
    [
        {
            'Attack': [
                {
                    'base': 1.5
                },
                {
                    'multi': 1.2
                },
            ]  
        },
        {
            'Health': [
                {
                    'base': 1.5
                },
                {
                    'multi': 1.2
                },
            ]  
        }

    ],
    'Epic':
    [
        {
            'Attack': [
                {
                    'base': 1.175
                },
                {
                    'multi': 1.15
                },
            ]  
        },
        {
            'Health': [
                {
                    'base': 1.175
                },
                {
                    'multi': 1.15
                },
            ]  
        },
        {
            'Base': [
                {
                    'base': 3
                },
                {
                    'multi': 1.35
                },
            ]  
        },
    ],
    'Rare':
    [
        {
            'Attack': [
                {
                    'base': 1.0725
                },
                {
                    'multi': 1.1
                },
            ]  
        },
        {
            'Health': [
                {
                    'base': 1.0725
                },
                {
                    'multi': 1.1
                },
            ]  
        }
    ],
    'Common':
    [
        {
            'Attack': [
                {
                    'base': 1.03
                },
                {
                    'multi': 1.05
                },
            ]  
        },
        {
            'Health': [
                {
                    'base': 1.03
                },
                {
                    'multi': 1.05
                },
            ]  
        }
    ] 
  }